import script from "./Co2QuizPartQuestionsField.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuizPartQuestionsField.vue?vue&type=script&lang=ts&setup=true"

import "./Co2QuizPartQuestionsField.vue?vue&type=style&index=0&id=664bac48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664bac48"]])

export default __exports__